import { createDeferredPortal } from "./createDeferredPortal";

export const mapControlsPortalId = "react-map-controls-portal";
export const MapControlsPortal = createDeferredPortal(mapControlsPortalId);

export const mapLegendPortalId = "react-map-legends-portal";
export const MapLegendPortal = createDeferredPortal(mapLegendPortalId);

export const mapSearchPortalId = "react-map-search-portal";
export const MapSearchPortal = createDeferredPortal(mapSearchPortalId);

export const mapLeftHandPanelPortalId = "react-map-left-hand-panel-portal";
export const MapLeftHandPanelPortal = createDeferredPortal(mapLeftHandPanelPortalId);

export const mapRightHandPanelPortalId = "react-map-right-hand-panel-portal";
export const MapRightHandPanelPortal = createDeferredPortal(mapRightHandPanelPortalId);

export const mapAttributionPortalId = "react-map-attribution-portal";
export const MapAttributionPortal = createDeferredPortal(mapAttributionPortalId);
